module.exports = __webpack_public_path__ + "static/media/savvy-public-gateway-checker.733c48b7.svg";